import React from "react";
import { motion } from "framer-motion";
import {
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
  FaFacebook,
  FaTwitter,
  FaLinkedin,
  FaInstagram,
} from "react-icons/fa";
import "./ContactUs.css";
import HeaderImage from "../assets/img/Whowearesectionimage.jpg";
import Footer from "../Home/Footer";

const ContactUs = () => {
  return (
    <div className="contact-container">
      {/* Hero */}
      <section
        className="contact-hero"
        style={{
          backgroundImage: `url(${HeaderImage})`,
        }}
      >
        <motion.div
          className="hero-overlay"
          initial={{ opacity: 0, y: -30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <h1>Get in Touch</h1>
          <p>We’d love to hear from you! Let’s start a conversation.</p>
        </motion.div>
      </section>

      {/* Contact Methods */}
      <section className="contact-methods">
        <motion.div
          className="contact-card"
          whileHover={{ scale: 1.03 }}
          transition={{ type: "spring", stiffness: 200 }}
        >
          <FaPhoneAlt className="contact-icon" />
          <h3>Call Us</h3>
          <p>+91 9822606267</p>
        </motion.div>

        <motion.div
          className="contact-card"
          whileHover={{ scale: 1.03 }}
          transition={{ type: "spring", stiffness: 200 }}
        >
          <FaEnvelope className="contact-icon" />
          <h3>Email</h3>
          <p>publicrelation@ipda.in</p>
          <p>smart.tspcsc@in.gt.com</p>
        </motion.div>

        <motion.div
          className="contact-card"
          whileHover={{ scale: 1.03 }}
          transition={{ type: "spring", stiffness: 200 }}
        >
          <FaMapMarkerAlt className="contact-icon" />
          <h3>Visit Us</h3>
          <p>
            3701 Tuljapur Khurad, Tuljapur, Osmanabad, Maharashtra, India,
            413601
          </p>
        </motion.div>
      </section>

      {/* Quick Links & Social Hub */}
      <section className="social-hub">
        <h2
          className="separator-title text-center"
          data-aos="fade-up"
          style={{ color: "#d4561a" }}
        >
          Connect With Us
        </h2>
        <div className="separator-line mb-5"></div>
        <div className="social-hub-grid">
          <a
            href=""
            target="_blank"
            rel="noopener noreferrer"
            className="social-hub-card"
          >
            <FaFacebook />
            <span>Facebook</span>
          </a>
          <a
            href="#"
            target="_blank"
            rel="noopener noreferrer"
            className="social-hub-card"
          >
            <FaTwitter />
            <span>Twitter</span>
          </a>
          <a
            href="https://www.linkedin.com/company/indo-pulses-development-association-ipda/"
            target="_blank"
            rel="noopener noreferrer"
            className="social-hub-card"
          >
            <FaLinkedin />
            <span>LinkedIn</span>
          </a>
          <a
            href="#"
            target="_blank"
            rel="noopener noreferrer"
            className="social-hub-card"
          >
            <FaInstagram />
            <span>Instagram</span>
          </a>
        </div>
      </section>

      {/* Map */}
      {/* Map */}
      {/* <div className="map-section">
        <iframe
          src="https://www.google.com/maps?q=3701%20Tuljapur%20Khurad%2C%20Tuljapur%2C%20Osmanabad%2C%20Maharashtra%20413601&hl=en&z=16&output=embed"
          allowFullScreen=""
          loading="lazy"
          title="Our Location"
        ></iframe>
      </div> */}

      <Footer />
    </div>
  );
};

export default ContactUs;
